export default __webpack_public_path__ + "static/media/captureThree.a7bc37de.jpg";